<template>
  <div class="home">
    <div>
            <div v-if="!isDetailClient">
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0 me-2">{{$t('clients')}}</h4>
                            </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center gap-2">
                            <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="search" :placeholder="$t('search')">
                            </div>
                            <!-- Mobile filter toggle -->
                            <button @click="showFilters = !showFilters" class="btn btn-outline-secondary d-md-none">
                                <SlidersIcon class="client-lucide-icon" :size="16" :stroke-width="1.75" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                    </div>
                </section>
            </div>
      
            <section class="">
                <div class="px-8">

                    <!-- Mobile action buttons -->
                    <div class="d-flex d-md-none gap-2 mb-3" v-if="!isDetailClient">
                        <template v-if="helper.checkAccess('create_clients') != -1">
                            <button @click="create" class="btn btn-sm btn-success flex-grow-1">
                                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                <span>{{$t('client')}}</span>
                            </button>
                        </template>
                        
                        <div class="dropdown">
                            <button class="btn btn-sm btn-light" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                <EllipsisIcon class="client-lucide-icon" :size="16" :stroke-width="1.75" aria-hidden="true" />
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                <li v-if="helper.checkAccess('create_clients') != -1">
                                    <a class="dropdown-item" href="#" @click="showUpload">{{$t('upload')}}</a>
                                </li>
                                <li>
                                    <a class="dropdown-item" href="#" @click="generatePDF">{{$t('generate_pdf')}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Filters section -->
                    <div class="row align-items-end g-2 mb-4" v-if="!isDetailClient" :class="{'d-none d-md-flex': !showFilters}">
                        
                        <!-- Filter Dropdown (Shopify Style) -->
                        <div class="col-12 col-md-auto">
                            <div class="dropdown">
                                <button class="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" id="filterDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <FunnelIcon class="me-1 client-lucide-icon" :size="14" :stroke-width="1.75" aria-hidden="true" /> {{$t('filter')}}
                                    <span v-if="activeFilters.length" class="badge bg-secondary ms-1">{{activeFilters.length}}</span>
                                </button>
                                <button v-if="activeFilters.length" class="btn btn-link btn-sm text-danger text-decoration-none ms-2" type="button" @click.stop="clearAllFilters">
                                    <CircleXIcon class="me-1 client-lucide-icon" :size="14" :stroke-width="1.75" aria-hidden="true" />{{$t('clear_all')}}
                                </button>
                                <div class="dropdown-menu p-3" aria-labelledby="filterDropdown" style="min-width: 300px;" @click.stop>
                                    
                                    <!-- Active Filters -->
                                    <div v-if="activeFilters.length > 0" class="mb-3">
                                        <div v-for="(filter, index) in activeFilters" :key="index" class="mb-2">
                                            <label class="form-label small mb-1">{{$t(filter.key)}}</label>
                                            <div class="input-group input-group-sm">
                                                <input type="text" v-model="filter.value" class="form-control form-control-sm" :placeholder="$t(filter.key)">
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <TrashIcon class="client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                                </button>
                                            </div>
                                        </div>
                                        <hr class="dropdown-divider">
                                    </div>

                                    <!-- Add Filter Options -->
                                    <div class="d-grid gap-2">
                                        <button v-for="filter in selectableFilters" :key="filter.key" 
                                                class="btn btn-sm btn-outline-primary text-start" 
                                                @click="addFilter(filter)">
                                            <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" /> {{$t(filter.key)}}
                                        </button>
                                    </div>

                                    <!-- Apply and Clear -->
                                    <div class="d-flex justify-content-between align-items-center mt-3">
                                        <button class="btn btn-sm btn-success" @click="applyFilters">
                                            {{$t('apply')}}
                                        </button>
                                        <button v-if="activeFilters.length > 0" class="btn btn-link btn-sm text-decoration-none text-danger p-0" @click="clearAllFilters">
                                            {{$t('clear_all')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Spacer for desktop -->
                        <div class="col d-none d-md-block"></div>

                        <div class="col-12 col-md-3 col-lg-2">
                            <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
                            <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                                <option value="">{{$t('filter_by_date')}}</option>
                                <option value="today">{{$t('today')}}</option>
                                <option value="yesterday">{{$t('yesterday')}}</option>
                                <option value="this_week">{{$t('this_week')}}</option>
                                <option value="last_week">{{$t('last_week')}}</option>
                                <option value="this_month">{{$t('this_month')}}</option>
                                <option value="custom">{{$t('custom_date')}}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
                            <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
                            <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
                        </div>
                        <template v-if="helper.checkAccess('create_clients') != -1">
                            <div class="col-md-2 d-none d-md-block">
                                <button @click="create" class="btn btn-sm btn-success w-100">
                                    <PlusIcon class="me-2 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                    <span>{{$t('client')}}</span>
                                </button>
                            </div>
                        </template>
                    </div>

                <div class="page-table-container mb-6 bg-white rounded shadow">

                    <!-- table -->
                    <div data-testid="client-table-scroll" class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small sticky-action-table" style="--sales-document-table-min-width: 1600px;">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6" style="width: 40px;">
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="checkbox" :checked="areAllSelected" @change="toggleSelectAll">
                                        </div>
                                    </th>
                                    <sortable-table-header v-if="visibleColumns.reference" field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <sortable-table-header v-if="visibleColumns.name" field="name" label="name" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <sortable-table-header v-if="visibleColumns.phone" field="phone" label="phone" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <sortable-table-header v-if="visibleColumns.email" field="email" label="email" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <sortable-table-header v-if="visibleColumns.address" field="address" label="address" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <sortable-table-header v-if="visibleColumns.city" field="city" label="city" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <sortable-table-header v-if="visibleColumns.state" field="state" label="state" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <sortable-table-header v-if="visibleColumns.zip_code" field="zip_code" label="zip_code" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <sortable-table-header v-if="visibleColumns.country" field="country" label="country" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <sortable-table-header v-if="visibleColumns.tax_id" field="tax_id" label="tax_id" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <sortable-table-header v-if="visibleColumns.vat_number" field="vat_number" label="vat_number" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <sortable-table-header v-if="clientCurrencyEnabled && visibleColumns.currency" field="currency" label="currency" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <th v-if="visibleColumns.ltv" class="pt-4 pb-3 px-6">{{$t('ltv')}}</th>
                                    <th v-if="visibleColumns.amount_paid" class="pt-4 pb-3 px-6">{{$t('amount_paid')}}</th>
                                    <th v-if="visibleColumns.balance_due" class="pt-4 pb-3 px-6">{{$t('client_balance_due')}}</th>
                                    <th v-if="visibleColumns.overdue" class="pt-4 pb-3 px-6">{{$t('overdue')}}</th>
                                    <sortable-table-header v-if="visibleColumns.created_at" field="created_at" label="created_at" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getClients)" />
                                    <th v-if="visibleColumns.created_by" class="pt-4 pb-3 px-6">{{$t('created_by')}}</th>
                                    <th v-if="visibleColumns.action" class="pt-4 pb-3 px-6 sticky-action-cell">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span>{{$t('action')}}</span>
                                            <div class="dropdown">
                                                <button class="btn btn-sm btn-link p-0 ms-2" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Columns">
                                                    <EllipsisIcon class="client-lucide-icon" :size="16" :stroke-width="1.75" aria-hidden="true" />
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end p-2" style="min-width: 200px; max-height: 300px; overflow-y: auto;">
                                                    <li v-if="helper.checkAccess('create_clients') != -1">
                                                        <a class="dropdown-item" href="#" @click="showUpload">{{$t('upload')}}</a>
                                                    </li>
                                                    <li>
                                                        <a class="dropdown-item" href="#" @click="generatePDF">{{$t('generate_pdf')}}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="client in clients" :key="client.id" :class="{'table-active': client.selected}">
                                <td class="py-5 px-6">
                                    <div class="form-check mb-0">
                                        <input class="form-check-input" type="checkbox" v-model="client.selected" @change="changeSelectedItem">
                                    </div>
                                </td>
                                <td v-if="visibleColumns.reference" class="py-5 px-6"> <router-link :to="`/clients/${client.id}`"><b>{{client.reference}}</b></router-link></td>
                                <td v-if="visibleColumns.name" class="py-5 px-6">
                                    <span :title="client.name || '-'" :aria-label="client.name || '-'">{{truncateEntityName(client.name)}}</span>
                                </td>
                                <td v-if="visibleColumns.phone" class="py-5 px-6">{{client.phone}}</td>
                                <td v-if="visibleColumns.email" class="py-5 px-6">{{client.email}}</td>
                                <td v-if="visibleColumns.address" class="py-5 px-6">
                                    <span class="client-address" :title="client.address || '-'">{{truncateAddress(client.address)}}</span>
                                </td>
                                <td v-if="visibleColumns.city" class="py-5 px-6">{{client.city || '-'}}</td>
                                <td v-if="visibleColumns.state" class="py-5 px-6">{{client.state || '-'}}</td>
                                <td v-if="visibleColumns.zip_code" class="py-5 px-6">{{client.zip_code || '-'}}</td>
                                <td v-if="visibleColumns.country" class="py-5 px-6">{{client.country || '-'}}</td>
                                <td v-if="visibleColumns.tax_id" class="py-5 px-6">{{client.tax_id || '-'}}</td>
                                <td v-if="visibleColumns.vat_number" class="py-5 px-6">{{client.vat_number || '-'}}</td>
                                <td v-if="clientCurrencyEnabled && visibleColumns.currency" class="py-5 px-6">{{client.currency || business.currency}}</td>
                                <td v-if="visibleColumns.ltv" class="py-5 px-6">{{ formatClientMoney(client.invoices.filter(invoice => invoice.status !== 'canceled').reduce((sum, invoice) => sum + invoice.total, 0).toFixed(2), client) }} </td>
                                <td v-if="visibleColumns.amount_paid" class="py-5 px-6">{{ formatClientMoney(client.transactions.filter(transaction => transaction.status === 'paid').reduce((sum, transaction) => sum + transaction.amount, 0).toFixed(2), client) }} </td>
                                <td v-if="visibleColumns.balance_due" class="py-5 px-6 fw-bold">{{formatClientMoney(clientBalanceDue(client), client)}}</td>
                                <td v-if="visibleColumns.overdue" class="py-5 px-6 fw-bold" :class="{'text-danger': clientOverdueAmount(client) > 0}">{{formatClientMoney(clientOverdueAmount(client), client)}}</td>
                                <td v-if="visibleColumns.created_at" class="py-5 px-6">{{formatDate(client.created_at)}}</td>
                                <td v-if="visibleColumns.created_by" class="py-5 px-6">{{client.user ? client.user.name : '-'}}</td>
                                <td v-if="visibleColumns.action" class="py-5 px-6 sticky-action-cell">
                                    <div class="sticky-row-actions">
                                        <button
                                            type="button"
                                            class="btn btn-primary btn-xs"
                                            style="padding: 5px; margin: 0; font-size: 12px !important; margin-right: 2px"
                                            :title="$t('details')"
                                            :aria-label="$t('details')"
                                            @click="goDetails(client.id)"
                                        >
                                            <EyeIcon class="client-lucide-icon" :size="14" :stroke-width="1.75" aria-hidden="true" />
                                            {{$t('details')}}
                                        </button>
                                        <button
                                            v-if="helper.checkAccess('edit_clients') != -1"
                                            type="button"
                                            class="btn btn-primary btn-xs"
                                            style="padding: 5px; margin: 0; font-size: 12px !important; margin-right: 2px"
                                            :title="$t('edit')"
                                            :aria-label="$t('edit')"
                                            @click="editRow(client)"
                                        >
                                            <PencilIcon class="client-lucide-icon" :size="14" :stroke-width="1.75" aria-hidden="true" />
                                            {{$t('edit')}}
                                        </button>
                                        <button
                                            v-if="helper.checkAccess('delete_clients') != -1"
                                            type="button"
                                            class="btn btn-primary btn-xs"
                                            style="padding: 5px; margin: 0; font-size: 12px !important"
                                            :title="$t('delete')"
                                            :aria-label="$t('delete')"
                                            @click="deleteRow(client)"
                                        >
                                            <TrashIcon class="client-lucide-icon" :size="14" :stroke-width="1.75" aria-hidden="true" />
                                            {{$t('delete')}}
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            </tbody>
                        </table>
                        <div v-if="count > clients.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getClients" />
                        </div>


                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !clients.length && !isFiltered" class="page-table-state text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
                        <UsersIcon class="text-muted client-lucide-icon" :size="48" :stroke-width="1.5" aria-hidden="true" />
                        <h4 class="mt-3">{{ $t('no_clients_added') }}</h4>
                        <p class="text-muted">{{ $t('start_by_adding_clients') }}</p>
                        <template v-if="helper.checkAccess('create_clients') != -1">
                            <button class="btn btn-outline-primary mt-2" @click="create">
                                {{ $t('add_first_client') }}
                            </button>
                        </template>
                    </div>
                    <div v-if="loading === false && !clients.length && isFiltered" class="page-table-state text-center" style="padding:1rem">{{$t('no_client_found')}}.</div>

                </div>

                <div class="col-sm-7">
                        {{$t('show')}}
                        <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                        {{$t('entities')}}
                </div>

                </div>
            </section>
      </div>

        <!-- Bulk Action Bar -->
        <div v-if="isSelectedItem" class="position-fixed bottom-0 start-50 translate-middle-x mb-4 p-3 bg-white shadow rounded d-flex align-items-center gap-3" style="z-index: 1050; border: 1px solid #dee2e6; min-width: 300px; justify-content: space-between;">
            <div class="d-flex align-items-center">
                <span class="fw-bold me-2">{{ selectedCount }}</span>
                <span class="text-muted">{{$t('selected')}}</span>
            </div>
            <div class="d-flex gap-2">
                <button v-if="helper.checkAccess('delete_clients') != -1" class="btn btn-danger btn-sm d-flex align-items-center" @click="deleteSelected">
                    <TrashIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" /> {{$t('delete')}}
                </button>
            </div>
        </div>

        <!-- Create Modal -->
        <add-client 
            v-if="createClientState" 
            :state="createClientState" 
            @createClient="handleCreateClient"
        />
        <!-- Create modal -->
        <!-- Create modal -->

        <!-- Upload Modal -->
        <div class="modal fade" id="uploadModal" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="uploadModalLabel">{{$t('upload_clients')}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <import-client @upload-success="uploadSuccess"></import-client>
            </div>
            </div>
        </div>
        </div>


        <!-- Edit Modal -->
        <div class="modal fade" id="edit-modal" tabindex="-1" aria-labelledby="edit-modal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content modern-modal">
                <div class="modal-header border-0 pb-0">
                    <div>
                        <h5 class="modal-title mb-0">
                            <PencilIcon class="me-2 client-lucide-icon" :size="19" :stroke-width="1.75" aria-hidden="true" />
                            {{$t('edit_client')}}
                        </h5>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body pt-2" style="text-align:left">
                    <div class="row g-2">
                        <div class="col-md-4">
                            <label for="editLabelInput" class="form-label">
                                {{$t('label')}} <span class="text-danger">*</span>
                            </label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <UserIcon class="client-lucide-icon" :size="16" :stroke-width="1.75" aria-hidden="true" />
                                </span>
                                <input 
                                    v-model="client.name" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    :class="{'is-invalid': validationErrors.name}"
                                    id="editLabelInput"
                                    @blur="validateField('name')"
                                >
                            </div>
                            <div v-if="validationErrors.name" class="invalid-feedback d-block">
                                {{validationErrors.name}}
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('phone')" class="col-md-4">
                            <label for="editPhoneInput" class="form-label">
                                {{$t('phone')}} <span class="text-danger">*</span>
                            </label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <PhoneIcon class="client-lucide-icon" :size="16" :stroke-width="1.75" aria-hidden="true" />
                                </span>
                                <input 
                                    v-model="client.phone" 
                                    type="tel" 
                                    class="form-control border-start-0 ps-0"
                                    :class="{'is-invalid': validationErrors.phone}"
                                    id="editPhoneInput"
                                    @blur="validateField('phone')"
                                >
                            </div>
                            <div v-if="validationErrors.phone" class="invalid-feedback d-block">
                                {{validationErrors.phone}}
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('email')" class="col-md-4">
                            <label for="editEmailInput" class="form-label">{{$t('email')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <MailIcon class="client-lucide-icon" :size="16" :stroke-width="1.75" aria-hidden="true" />
                                </span>
                                <input 
                                    v-model="client.email" 
                                    type="email" 
                                    class="form-control border-start-0 ps-0"
                                    :class="{'is-invalid': validationErrors.email}"
                                    id="editEmailInput"
                                    @blur="validateField('email')"
                                >
                            </div>
                            <div v-if="validationErrors.email" class="invalid-feedback d-block">
                                {{validationErrors.email}}
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('address')" class="col-md-12">
                            <label for="editAddressInput" class="form-label">{{$t('address')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <HouseIcon class="client-lucide-icon" :size="16" :stroke-width="1.75" aria-hidden="true" />
                                </span>
                                <textarea 
                                    v-model="client.address" 
                                    class="form-control border-start-0 ps-0" 
                                    id="editAddressInput" 
                                    rows="2"
                                ></textarea>
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('city')" class="col-md-3">
                            <label for="editCityInput" class="form-label">{{$t('city')}}</label>
                            <input v-model="client.city" type="text" class="form-control" id="editCityInput">
                        </div>
                        <div v-if="isClientFieldVisible('state')" class="col-md-3">
                            <label for="editStateInput" class="form-label">{{$t('state')}}</label>
                            <input v-model="client.state" type="text" class="form-control" id="editStateInput">
                        </div>
                        <div v-if="isClientFieldVisible('zip_code')" class="col-md-3">
                            <label for="editZipCodeInput" class="form-label">{{$t('zip_code')}}</label>
                            <input v-model="client.zip_code" type="text" class="form-control" id="editZipCodeInput">
                        </div>
                        <div v-if="isClientFieldVisible('country')" class="col-md-3">
                            <label for="editCountryInput" class="form-label">{{$t('country')}}</label>
                            <input v-model="client.country" type="text" class="form-control" id="editCountryInput">
                        </div>
                        <div v-if="clientCurrencyEnabled && isClientFieldVisible('currency')" class="col-md-6">
                            <label for="editClientCurrencyInput" class="form-label">{{$t('currency')}}</label>
                            <select v-model="client.currency" class="form-select" id="editClientCurrencyInput">
                                <option value="">{{$t('default')}} ({{business.currency}})</option>
                                <option v-for="option in currencyOptions" :key="option.value" :value="option.value">
                                    {{option.label}}
                                </option>
                            </select>
                        </div>
                        <div v-if="isClientFieldVisible('tax_id')" class="col-md-6">
                            <label for="editTaxIdInput" class="form-label">{{$t('tax_id')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <HashIcon class="client-lucide-icon" :size="16" :stroke-width="1.75" aria-hidden="true" />
                                </span>
                                <input 
                                    v-model="client.tax_id" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    id="editTaxIdInput"
                                >
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('vat_number')" class="col-md-6">
                            <label for="editVatNumberInput" class="form-label">{{$t('vat_number')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <HashIcon class="client-lucide-icon" :size="16" :stroke-width="1.75" aria-hidden="true" />
                                </span>
                                <input 
                                    v-model="client.vat_number" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    id="editVatNumberInput"
                                >
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('notes')" class="col-md-12">
                            <collapsible-notes-field v-model="client.notes" id="client-edit-notes" rows="2" />
                        </div>
                    </div>

                </div>
                <div class="modal-footer border-0 pt-0">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                        <XIcon class="me-1 client-lucide-icon" :size="14" :stroke-width="1.75" aria-hidden="true" />{{$t('close')}}
                    </button>
                    <button type="button" class="btn btn-success" :disabled="loading || !isFormValid" @click="updateRow">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <PencilIcon v-else class="me-2 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                        {{$t('update')}}
                    </button>
                </div>
                </div>
            </div>
        </div>
        <!-- Edit modal -->

  </div>
</template>

<script>
// @ is an alias to /src
import helper from '../../helper'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import AddClient from '../../components/AddClient.vue';

import ImportClient from '../../components/ImportClient.vue'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { getCrmTableColumnDefaults } from '../../constants/crmTableColumns'
import { getCrmClientFormFieldDefaults } from '../../constants/crmClientFormFields'
import { CURRENCY_OPTIONS } from '../../constants/currencies'
import sortableList from '../../mixins/sortableList'
import EyeIcon from 'lucide-vue/dist/esm/icons/eye.js'
import CircleXIcon from 'lucide-vue/dist/esm/icons/circle-x.js'
import EllipsisIcon from 'lucide-vue/dist/esm/icons/ellipsis-vertical.js'
import FunnelIcon from 'lucide-vue/dist/esm/icons/funnel.js'
import HashIcon from 'lucide-vue/dist/esm/icons/hash.js'
import HouseIcon from 'lucide-vue/dist/esm/icons/house.js'
import MailIcon from 'lucide-vue/dist/esm/icons/mail.js'
import PencilIcon from 'lucide-vue/dist/esm/icons/pencil.js'
import PhoneIcon from 'lucide-vue/dist/esm/icons/phone.js'
import PlusIcon from 'lucide-vue/dist/esm/icons/plus.js'
import SlidersIcon from 'lucide-vue/dist/esm/icons/sliders-horizontal.js'
import TrashIcon from 'lucide-vue/dist/esm/icons/trash-2.js'
import UserIcon from 'lucide-vue/dist/esm/icons/user-round.js'
import UsersIcon from 'lucide-vue/dist/esm/icons/users.js'
import XIcon from 'lucide-vue/dist/esm/icons/x.js'

export default {
  name: 'Client',
  persistedFilterState: {
    key: 'clients',
    fields: ['search', 'activeFilters', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components :{
    DatePicker,
    AddClient,
    ImportClient,
    CircleXIcon,
    EllipsisIcon,
    EyeIcon,
    FunnelIcon,
    HashIcon,
    HouseIcon,
    MailIcon,
    PencilIcon,
    PhoneIcon,
    PlusIcon,
    SlidersIcon,
    TrashIcon,
    UserIcon,
    UsersIcon,
    XIcon
  },
  props : ['user_id','isDetailClient'],
  data(){
    return {
        uploadModal: null,
        search : '',
        clients : [],
        count : 0,
        page : 1,
        pagination : [],
        client : {
            id : null,
            name : '',
            email : '',
            phone : '',
            ice : '',
            address : '',
            notes : '',
            city: '',
            state: '',
            zip_code: '',
            country: '',
            currency: '',
            tax_id: '',
            vat_number: '',
        },
        range: [],
        start : null,
        end : null,
        dateRangeOption: '',
        activeFilters: [],
        availableFilters: [
            { key: 'name' },
            { key: 'email' },
            { key: 'phone' },
            { key: 'address' },
            { key: 'city' },
            { key: 'country' },
            { key: 'tax_id' },
            { key: 'vat_number' }
        ],
        createClientState: false,
        // createModal : null,
        editModal : null,
        loading : false,
        per_page : 25,
        url : '',
        showFilters: false,
        searchTimeout : null,
        validationErrors: {
            name: '',
            email: '',
            phone: ''
        },
        isSelectedItem: false,
        visibleColumns: getCrmTableColumnDefaults('clients')
    }
  }, 
  mounted(){
    window.mixpanel.track("client");
    
    //check permissions
    if(helper.checkAccess('view_clients') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_clients') == -2) return this.$router.push({path : '/subscribe'})

    // Initialize this_month date range
    // this.handleDateRangeChange()
    
    this.loadColumnSettings()
    this.getClients()

    // eslint-disable-next-line no-undef
    // this.createModal = new bootstrap.Modal(document.getElementById('create-modal'),{backdrop: 'static', keyboard: false})
    
    // eslint-disable-next-line no-undef
    this.editModal = new bootstrap.Modal(document.getElementById('edit-modal'),{backdrop: 'static', keyboard: false})
  },
  methods : {
    truncateEntityName(name) {
        if (!name) return '-'
        return name.length > 20 ? `${name.slice(0, 20)}...` : name
    },
    isClientFieldVisible(field) {
        return this.clientFormFields[field] !== false
    },
    loadColumnSettings() {
        const savedColumns = this.business?.metadata?.crm_clients_columns
        if (savedColumns) {
            this.visibleColumns = {
                ...getCrmTableColumnDefaults('clients'),
                ...savedColumns
            }
        }
    },
    formatMoney(number) { return helper.formatMoney(number);},
    formatClientMoney(number, client) {
        const currency = this.clientCurrencyEnabled
            ? (client?.currency || this.business.currency)
            : this.business.currency
        return helper.formatMoney(number, currency)
    },
    truncateAddress(address, maxWords = 5, maxCharacters = 35) {
        if (!address) return '-'

        const normalizedAddress = String(address).trim().split(/\s+/).join(' ')
        const words = normalizedAddress.split(' ')

        if (words.length > maxWords) {
            return `${words.slice(0, maxWords).join(' ')}...`
        }

        if (normalizedAddress.length > maxCharacters) {
            return `${normalizedAddress.slice(0, maxCharacters).trim()}...`
        }

        return normalizedAddress
    },
    invoiceOutstandingAmount(invoice) {
        if (!invoice) return 0

        const status = String(invoice.status || '').toLowerCase()
        if (['canceled', 'draft'].includes(status)) return 0

        const total = parseFloat(invoice.total) || 0
        const paid = parseFloat(invoice.amount_paid) || 0
        return Math.max(total - paid, 0)
    },
    clientBalanceDue(client) {
        return (client.invoices || []).reduce((sum, invoice) => {
            return sum + this.invoiceOutstandingAmount(invoice)
        }, 0)
    },
    clientOverdueAmount(client) {
        const today = moment().startOf('day')

        return (client.invoices || []).reduce((sum, invoice) => {
            const outstanding = this.invoiceOutstandingAmount(invoice)
            if (outstanding <= 0) return sum

            const status = String(invoice.status || '').toLowerCase()
            const isPastDue = invoice.due_date && moment(invoice.due_date).isBefore(today)

            return status === 'overdue' || isPastDue ? sum + outstanding : sum
        }, 0)
    },
    create(){
        this.createClientState = true
    },
    handleCreateClient(data){
        this.createClientState = data.state
        if(data.client){
            this.getClients()
        }
    },
    editRow(row){
        this.client = { ...row, currency: row.currency || '' }
        this.validationErrors = { name: '', email: '', phone: '' }
        this.editModal.show()
    },
    validateField(field) {
        if (field === 'name') {
            if (!this.client.name || this.client.name.trim() === '') {
                this.validationErrors.name = this.$t('name_required') || 'Name is required'
            } else if (this.client.name.length < 2) {
                this.validationErrors.name = this.$t('name_too_short') || 'Name must be at least 2 characters'
            } else {
                this.validationErrors.name = ''
            }
        }
        
        if (field === 'phone') {
            if (!this.isClientFieldVisible('phone')) {
                this.validationErrors.phone = ''
                return
            }
            if (!this.client.phone || this.client.phone.trim() === '') {
                this.validationErrors.phone = this.$t('phone_required') || 'Phone is required'
            } else {
                this.validationErrors.phone = ''
            }
        }
        
        if (field === 'email' && !this.isClientFieldVisible('email')) {
            this.validationErrors.email = ''
        } else if (field === 'email' && this.client.email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(this.client.email)) {
                this.validationErrors.email = this.$t('invalid_email') || 'Invalid email format'
            } else {
                this.validationErrors.email = ''
            }
        } else if (field === 'email') {
            this.validationErrors.email = ''
        }
    },
    validateForm() {
        this.validateField('name')
        if (this.isClientFieldVisible('phone')) this.validateField('phone')
        if (this.isClientFieldVisible('email')) this.validateField('email')
        
        return !this.validationErrors.name && !this.validationErrors.phone && !this.validationErrors.email
    },
    //crud
    //crud
    // saveRow moved to AddClient component
    async updateRow(){
        if (!this.validateForm()) {
            this.$swal.fire({
                icon: 'error',
                title: this.$t('validation_error') || 'Validation Error',
                text: this.$t('please_fix_errors') || 'Please fix the errors before submitting'
            })
            return
        }
        
        try{
            this.loading = true
            await helper.customPatch(`${process.env.VUE_APP_API}/clients/${this.client.id}`,this.client)
            this.loading = false
            this.clearForm()
            this.editModal.hide()
            this.getClients()
        }catch(error){
            this.loading = false
        }
    },
    async deleteRow(row){
        const result = await this.$swal.fire({
            title: `${this.$t('are_you_sure')}?`,
            text : this.$t('you_cant_revert'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes_delete_it')
        })
        if (result.isConfirmed) {
            await helper.customDelete(`${process.env.VUE_APP_API}/clients/${row.id}`)
            this.clients = helper.withoutDeletedRecords(this.clients, row.id)
            this.count = Math.max(0, this.count - 1)
        }
    },
    clearForm(){
        this.client = {
            id : null,
            name : '',
            email : '',
            phone : '',
            address : '',
            notes : '',
            city: '',
            state: '',
            zip_code: '',
            country: '',
            currency: '',
            tax_id: '',
            vat_number: '',
        }
        this.validationErrors = {
            name: '',
            email: '',
            phone: ''
        }
    },
    async getClients(page){
        try{
            this.loading = true
            this.page = page ? page : 1

            // Build query params
            const params = new URLSearchParams();
            params.append('page', this.page);
            params.append('per_page', this.per_page);
            this.appendSortParams(params);

            if (this.start) {
                params.append('start', this.start);
                params.append('end', this.end);
            }

            if (this.search && this.search.length > 0) {
                params.append('keyword', this.search);
            }

            // Add Shopify-style active filters
            for (const filter of this.activeFilters) {
                if (filter.value && filter.value.toString().trim() !== '') {
                    params.append(filter.key, filter.value);
                }
            }

            if (this.user_id) {
                params.append('user_id', this.user_id);
            }

            let url = `${process.env.VUE_APP_API}/clients?${params.toString()}`;

            this.clients = []
            
            const response = await helper.customGet(url)
            this.clients =  response.data.data
            
            for(let i = 0 ; i < this.clients.length ; i++){
                this.$set(this.clients[i], 'selected', false)
            }

            this.count = response.data.count
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }

            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }

            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    showUpload(){
        // eslint-disable-next-line no-undef
        this.uploadModal = new bootstrap.Modal(document.getElementById('uploadModal'))
        this.uploadModal.show()
    },
    uploadSuccess(){
        this.uploadModal.hide()
        this.getClients()
        this.$toast.open({
            message: this.$t('clients_imported_successfully'),
            type: 'success',
            position: 'bottom'
        })
    },
    generatePDF() {
        const doc = new jsPDF()
        
        // Add title
        doc.setFontSize(18)
        doc.text(this.$t('clients_list'), 14, 22)
        
        // Add date
        doc.setFontSize(11)
        doc.text(helper.formatDate(new Date()), 14, 30)
        
        // Define columns
        const columns = [
            { header: this.$t('reference'), dataKey: 'reference' },
            { header: this.$t('name'), dataKey: 'name' },
            { header: this.$t('phone'), dataKey: 'phone' },
            { header: this.$t('email'), dataKey: 'email' },
            { header: this.$t('address'), dataKey: 'address' },
            { header: this.$t('created_at'), dataKey: 'created_at' }
        ]
        
        // Prepare data
        const data = this.clients.map(client => ({
            reference: client.reference,
            name: client.name,
            phone: client.phone || '-',
            email: client.email || '-',
            address: client.address || '-',
            created_at: helper.formatDate(client.created_at)
        }))
        
        // Generate table
        autoTable(doc, {
            head: [columns.map(col => col.header)],
            body: data.map(row => columns.map(col => row[col.dataKey])),
            startY: 35,
            theme: 'grid',
            styles: { fontSize: 8 },
            headStyles: { fillColor: [41, 128, 185] }
        })
        
        // Save PDF
        doc.save('clients_list.pdf')
    },
    goDetails(id){ this.$router.push({path: `/clients/${id}`, params : { id }}) },
    //helper functions
    formatDate(date) { return helper.formatDate(date) },
    addFilter(filter) {
        if (!this.isFilterActive(filter.key)) {
            this.activeFilters.push({ 
                key: filter.key, 
                value: '' 
            });
        }
    },
    removeFilter(index) {
        this.activeFilters.splice(index, 1);
    },
    isFilterActive(key) {
        return this.activeFilters.some(f => f.key === key);
    },
    applyFilters() {
        this.getClients();
    },
    clearAllFilters() {
        this.activeFilters = [];
        this.getClients();
    },
    debouncedSearch(){
        // Clear existing timeout
        if(this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
        
        // Set new timeout
        this.searchTimeout = setTimeout(() => {
            this.getClients()
        }, 500) // 500ms delay
    },

    changeSelectedItem(){
        this.isSelectedItem = this.clients.find(client => client.selected === true ) ? true : false
    },
    toggleSelectAll() {
      const newState = !this.areAllSelected;
      this.clients.forEach(c => c.selected = newState);
      this.changeSelectedItem();
    },
    async deleteSelected() {
      const selectedIds = this.clients.filter(c => c.selected).map(c => c.id);
      if (selectedIds.length === 0) return;

      this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      }).then(async (result) => {
        if (result.isConfirmed) {
            this.loading = true;
            try {
                const results = await Promise.allSettled(selectedIds.map(id => helper.customDelete(`${process.env.VUE_APP_API}/clients/${id}`)));
                const deletedIds = helper.fulfilledRecordIds(selectedIds, results);
                this.clients = helper.withoutDeletedRecords(this.clients, deletedIds);
                this.count = Math.max(0, this.count - deletedIds.length);
                if (deletedIds.length !== selectedIds.length) throw results.find(result => result.status === 'rejected').reason;
                this.isSelectedItem = false;
                this.$toast.open({
                    message: this.$t('clients_deleted_successfully'),
                    type: 'success',
                    position: 'bottom'
                });
            } catch (error) {
                this.$toast.open({
                    message: this.$t('error_occurred'),
                    type: 'error',
                    position: 'bottom'
                });
            } finally {
                this.loading = false;
            }
        }
      });
    },
    // Handle date range selection
    handleDateRangeChange() {
        if (this.dateRangeOption === '') {
            // All dates - clear range
            this.range = [];
            this.start = null;
            this.end = null;
            this.getClients();
        } else if (this.dateRangeOption === 'today') {
            const start = new Date();
            const end = new Date();
            this.range = [start, end];
        } else if (this.dateRangeOption === 'yesterday') {
            const start = new Date();
            const end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            end.setTime(end.getTime() - 3600 * 1000 * 24);
            this.range = [start, end];
        } else if (this.dateRangeOption === 'this_week') {
            const start = new Date();
            const end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            this.range = [start, end];
        } else if (this.dateRangeOption === 'last_week') {
            const start = new Date();
            const end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
            this.range = [start, end];
        } else if (this.dateRangeOption === 'this_month') {
            const start = new Date();
            const end = new Date();
            start.setDate(1);
            this.range = [start, end];
        } else if (this.dateRangeOption === 'custom') {
            // Don't set range yet, wait for user to pick dates
            this.range = [];
        }
    },

  },
  watch : {
    async search(){
        if(this.search.length > 2 || this.search.length === 0){
            this.debouncedSearch()
        }
    },
    range(){

        if(this.range[0] == null){
            this.start = null
            this.end = null
            this.getClients()
        }

        if(this.range.length && this.range[0] && this.range[1]){
            this.start = moment(this.range[0]).format('YYYY-MM-DD')
            this.end = moment(this.range[1]).format('YYYY-MM-DD')
            this.getClients()
        }else{
            this.clients = []
        }

    },
    per_page(){
        this.getClients(this.page)
    }
  },
   computed : {
    selectableFilters() {
        return this.availableFilters.filter(f => !this.isFilterActive(f.key));
    },
    isFiltered() {
      return (this.activeFilters.length > 0) || 
             (this.search && this.search.length > 0) ||
             (this.dateRangeOption && this.dateRangeOption !== '') ||
             (this.range && this.range.length > 0);
    },
    role(){ return this.$store.getters.ROLE },
    business(){ return this.$store.getters.BUSINESS},
    clientCurrencyEnabled(){
        return !!this.business?.metadata?.use_client_currency_for_invoices
    },
    clientFormFields(){
        return {
            ...getCrmClientFormFieldDefaults(),
            ...(this.business?.metadata?.crm_client_form_fields || {}),
            name: true
        }
    },
    currencyOptions(){ return CURRENCY_OPTIONS },
    helper(){ return helper },
    isFormValid() {
        const hasRequiredPhone = !this.isClientFieldVisible('phone') || !!this.client.phone
        const hasValidEmail = !this.isClientFieldVisible('email') || !this.client.email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.client.email)
        return this.client.name && 
               this.client.name.trim().length >= 2 && 
               hasRequiredPhone &&
               hasValidEmail
    },
    areAllSelected() {
      return this.clients.length > 0 && this.clients.every(c => c.selected);
    },
    selectedCount() {
      return this.clients.filter(c => c.selected).length;
    }
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }

    .client-lucide-icon {
        display: inline-block;
        flex: 0 0 auto;
        vertical-align: -0.125em;
    }

    .client-address {
        display: inline-block;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        white-space: nowrap;
    }
    
    .advanced-search-section {
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        border: 1px solid #dee2e6;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    
    .filter-input {
        transition: all 0.3s ease;
    }
    
    .filter-input:focus {
        border-color: #303030;
        box-shadow: 0 0 0 0.2rem rgba(83, 77, 255, 0.25);
    }
    
    .btn-outline-primary {
        border-color: #cbd5e1;
        color: #334155;
    }
    
    .btn-outline-primary:hover {
        background-color: #004aad;
        border-color: #004aad;
        color: white;
    }
    
    .btn-outline-primary.active {
        background-color: #004aad;
        border-color: #004aad;
        color: white;
    }

    /* Modern Modal Styles */
    .modern-modal {
        border: none;
        border-radius: 16px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    }

    .modern-modal .modal-header {
        padding: 1rem 1.5rem 0.75rem;
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
    }

    .modern-modal .modal-title {
        font-weight: 600;
        color: #2c3e50;
    }

    .modern-modal .modal-body {
        padding: 1rem 1.5rem;
        max-height: 70vh;
        overflow-y: auto;
    }

    .modern-modal .modal-footer {
        padding: 0.75rem 1.5rem 1rem;
        background-color: #f8f9fa;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
    }

    /* Form Section Styles */
    .form-section {
        padding: 0.875rem;
        background-color: #ffffff;
        border-radius: 12px;
        border: 1px solid #e9ecef;
        transition: all 0.3s ease;
    }

    .form-section:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        border-color: #dee2e6;
    }

    .section-title {
        font-size: 0.9rem;
        font-weight: 600;
        color: #495057;
        margin-bottom: 0.75rem;
        padding-bottom: 0.5rem;
        border-bottom: 2px solid #e9ecef;
        display: flex;
        align-items: center;
    }

    .section-title i {
        color: #6c757d;
        font-size: 1.1rem;
    }

    /* Enhanced Input Styles */
    .input-group-text {
        background-color: #f8f9fa;
        border-color: #dee2e6;
        color: #6c757d;
        transition: all 0.3s ease;
    }

    .input-group:focus-within .input-group-text {
        background-color: #e9ecef;
        color: #495057;
        border-color: #80bdff;
    }

    .form-control {
        border-color: #dee2e6;
        transition: all 0.3s ease;
    }

    .form-control:focus {
        border-color: #80bdff;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
    }

    .form-control.is-invalid {
        border-color: #dc3545;
        background-image: none;
    }

    .form-control.is-invalid:focus {
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.15);
    }

    /* Form Label Styles */
    .form-label {
        font-size: 0.85rem;
        font-weight: 500;
        color: #495057;
        margin-bottom: 0.375rem;
    }

    .form-label .text-danger {
        font-size: 1rem;
        margin-left: 2px;
    }

    /* Invalid Feedback Styles */
    .invalid-feedback {
        font-size: 0.8125rem;
        margin-top: 0.25rem;
        animation: slideDown 0.3s ease;
    }

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-5px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Button Styles */
    .btn {
        font-weight: 500;
        padding: 0.5rem 1.25rem;
        border-radius: 8px;
        transition: all 0.3s ease;
    }

    .btn-light {
        background-color: #f8f9fa;
        border-color: #dee2e6;
        color: #495057;
    }

    .btn-light:hover {
        background-color: #e2e6ea;
        border-color: #dae0e5;
        color: #495057;
    }

    .btn-success {
        background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
        border: none;
        box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);
    }

    .btn-success:hover {
        background: linear-gradient(135deg, #218838 0%, #1aa179 100%);
        box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
        transform: translateY(-1px);
    }

    .btn-success:disabled {
        background: linear-gradient(135deg, #6c757d 0%, #868e96 100%);
        box-shadow: none;
        cursor: not-allowed;
        opacity: 0.65;
    }

    /* Placeholder Styles */
    ::placeholder {
        color: #adb5bd;
        opacity: 1;
        font-size: 0.875rem;
    }

    /* Scrollbar Styles for Modal Body */
    .modal-body::-webkit-scrollbar {
        width: 8px;
    }

    .modal-body::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }

    .modal-body::-webkit-scrollbar-thumb {
        background: #cbd5e0;
        border-radius: 10px;
    }

    .modal-body::-webkit-scrollbar-thumb:hover {
        background: #a0aec0;
    }

    /* Textarea Styles */
    textarea.form-control {
        resize: vertical;
        min-height: 60px;
    }

    /* Responsive Adjustments */
    @media (max-width: 768px) {
        .modern-modal .modal-header,
        .modern-modal .modal-body,
        .modern-modal .modal-footer {
            padding-left: 1rem;
            padding-right: 1rem;
        }

        .form-section {
            padding: 1rem;
        }

        .modal-xl {
            max-width: 95%;
        }
    }
</style>
